/* eslint-disable camelcase */
import React from 'react'
import './style.scss'

export const PastTicketCard = (props) => {
  const today = new Date()
  const {
    foto_portada,
    fecha_asistencia
  } = props
  const dia = Number(fecha_asistencia.substring(0, 2))
  const mes = Number(fecha_asistencia.substring(3, 5))
  const año = Number(fecha_asistencia.substring(6, 10))

  if (año <= today.getFullYear() && mes < (today.getMonth() + 1)) {
    return (
      <div className="cardTicket2">
        <div className='row'>
          <div className="col-md-4">
            <div className="img-wrapper4">
              <img src={foto_portada} className="square card-img-top" />
            </div>
          </div>
          <div className="col-md-6 mt-4">
            <h4>Nombre</h4>
            <ul className="list-unstyled mb-5">
              <li className="d-flex align-items-center mb-2">
                <b>Fecha: {fecha_asistencia}</b>
              </li>
              <li className="d-flex align-items-center mb-2 flex-wrap"> {/* Le agregué flex-wrap al final para que se vea la dirección abajo en móvil */}
                <b> Hora inicio - Hora fin</b>
              </li>
              <li className="d-flex align-items-center mb-2">
                <b>Ciudad: Ciudad</b>
              </li>
              <li className="d-flex align-items-center mb-2">
                <b>Direccion: Dirección</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  } else if ((año === today.getFullYear() && mes === (today.getMonth() + 1) && dia < today.getDate())) {
    return (
      <div className="cardTicket">
        <div className='row'>
          <div className="col-md-4 mb-4 mt-4">
            <div className="img-wrapper3">
              <img src={foto_portada} className="square card-img-top" />
            </div>
          </div>
          <div className="col-md-6">
            <h4> Nombre </h4>
            <ul className="list-unstyled mb-5">
              <li className="d-flex align-items-center mb-2">
                <b>Fecha: {fecha_asistencia}</b>
              </li>
              <li className="d-flex align-items-center mb-2 flex-wrap"> {/* Le agregué flex-wrap al final para que se vea la dirección abajo en móvil */}
                <b> Hora Inicio - Hora Final</b>
              </li>
              <li className="d-flex align-items-center mb-2">
                <b>Ciudad: Ciudad</b>
              </li>
              <li className="d-flex align-items-center mb-2">
                <b>Direccion: Dirección</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
